import { RouterProvider } from "react-router-dom";
import router from "./common/routerConfig";

import "./styles/app.scss";
import "react-datepicker/dist/react-datepicker.css";

const App = () => {
    return <RouterProvider router={router} />;
}

export default App;
